import LandingFullFooter from '../../legacy/components/landingSnapshot/LandingFullFooter.jsx';

// Keep the public marketing footer fixed across landing, listing, and detail routes.
export default function PublicSiteFooter() {
  return <LandingFullFooter />;
}
